// Lucide icon: book-a (https://lucide.dev/icons/book-a)
import { BookA } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconAccountsPayable = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <BookA />
    </IconComponentStyled>
  )
}
